(function () {
  'use strict';

  // Replace with your website-1c domain
  const MY_PAY_API_URL = 'https://1c-app.ashleyhome.am/api/get-my-pay-price.php';
  const MIN_AMOUNT = 10000;

  const cache = new Map();
  const pending = new Map();

  function formatAmd(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) return String(value);
    return new Intl.NumberFormat('hy-AM').format(num);
  }

  function hideBlock(block) {
    if (!block) return;
    block.classList.remove('active');
  }

  function showBlock(block) {
    if (!block) return;
    block.classList.add('active');
  }

  function fetchPaymentAmount(amount) {
    if (cache.has(amount)) {
      return Promise.resolve(cache.get(amount));
    }

    if (pending.has(amount)) {
      return pending.get(amount);
    }

    const url = MY_PAY_API_URL + '?amount=' + encodeURIComponent(amount);
    const request = fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        if (!data || data.status !== 'success' || data.paymentAmount == null) {
          throw new Error((data && data.message) || 'MyPay API error');
        }
        cache.set(amount, data.paymentAmount);
        return data.paymentAmount;
      })
      .finally(function () {
        pending.delete(amount);
      });

    pending.set(amount, request);
    return request;
  }

  function updateBlock(block) {
    if (!block || !block.hasAttribute('data-my-pay-amount')) return;

    const amount = parseInt(block.getAttribute('data-my-pay-amount'), 10);
    const target = block.querySelector('[data-my-pay-price]');

    if (!Number.isFinite(amount) || amount <= MIN_AMOUNT || !target) {
      hideBlock(block);
      return;
    }

    fetchPaymentAmount(amount)
      .then(function (paymentAmount) {
        if (!block.isConnected) return;
        if (parseInt(block.getAttribute('data-my-pay-amount'), 10) !== amount) return;
        target.textContent = formatAmd(paymentAmount);
        showBlock(block);
      })
      .catch(function () {
        if (!block.isConnected) return;
        if (parseInt(block.getAttribute('data-my-pay-amount'), 10) !== amount) return;
        hideBlock(block);
      });
  }

  function updateAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const blocks = scope.querySelectorAll('[data-my-pay-amount]');
    blocks.forEach(updateBlock);
  }

  function findPriceBlockNear(element) {
    const form = element.closest('form');
    if (form) {
      const inForm = form.querySelector('[data-my-pay-amount]');
      if (inForm) return inForm;

      const section = form.closest('.shopify-section, section, product-info, .product');
      if (section) {
        const inSection = section.querySelector('[data-my-pay-amount]');
        if (inSection) return inSection;
      }
    }
    return null;
  }

  function onVariantIdChange(event) {
    const input = event.target;
    if (!input || input.name !== 'id') return;

    const option = input.tagName === 'SELECT'
      ? input.options[input.selectedIndex]
      : input;

    if (!option) return;

    // Prefer cents from theme data attributes when present
    const priceCents = option.getAttribute('data-price')
      || option.dataset.price
      || input.getAttribute('data-price');

    const block = findPriceBlockNear(input);
    if (!block) {
      updateAll(document);
      return;
    }

    if (priceCents != null && priceCents !== '') {
      const cents = parseInt(priceCents, 10);
      if (Number.isFinite(cents)) {
        const amount = Math.floor(cents / 100);
        if (amount <= MIN_AMOUNT) {
          hideBlock(block);
          return;
        }
        block.setAttribute('data-my-pay-amount', String(amount));
        updateBlock(block);
        return;
      }
    }

    updateBlock(block);
  }

  function init() {
    updateAll(document);

    document.addEventListener('change', onVariantIdChange, true);

    document.addEventListener('shopify:section:load', function (event) {
      updateAll(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MyPayPrice = {
    updateAll: updateAll,
    updateBlock: updateBlock,
  };
})();
